<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <!-- Filter Section Start-->
        <div class="md-layout">
          <!-- Search Term Input -->
          <div class="md-layout-item md-small-size-100 md-size-0">
            <md-field>
              <label for="mtype">Search Term</label>
              <md-input
                name="term"
                id="term"
                v-model="transactionQuery.term"
                @md-selected="targetField('term', $event)"
              ></md-input>
              <!-- <md-icon>search</md-icon> -->
            </md-field>
          </div>

          <!-- Dropdown Filter -->
          <div class="md-layout-item md-small-size-100 md-size-33">
            <md-field>
              <label>Date</label>
              <md-select v-model="dateFilter">
                <md-option value="ALL">All Time</md-option>
                <md-option value="DAY">Last 24 Hours</md-option>

                <md-option value="MONTH">Last 30 Days</md-option>
                <md-option value="YEAR">Last 12 Months</md-option>
                <md-option value="CUSTOM">Custom</md-option>
              </md-select>
            </md-field>
          </div>
          <!-- Date From -->
          <div
            class="md-layout-item md-small-size-100 md-size-20"
            v-if="showDatePicker"
          >
            <md-datepicker md-immediately v-model="transactionQuery.start">
              <label>Date From</label>
            </md-datepicker>
          </div>

          <!-- Date To -->
          <div
            class="md-layout-item md-small-size-100 md-size-20"
            v-if="showDatePicker"
          >
            <md-datepicker md-immediately v-model="transactionQuery.end">
              <label>Date To</label>
            </md-datepicker>
          </div>
        </div>
        <!-- Filter Section End -->

        <!-- Filter Section: Action Buttons -->
        <div>
          <md-button class="md-raised md-success" @click="filterTransactions()"
            >Filter</md-button
          >

          <md-button class="md-raised md-danger" @click="resetQuery()"
            >Reset</md-button
          >
          <md-button class="md-raised md-primary" @click="exportToExcel()"
            >Export List</md-button
          >
        </div>
        <!-- Filter Section: Action Buttons End -->

        <!-- <FilterOrders @reset="resetQuery" @filter="filterTransactions"/> -->

        <!-- Table -->
        <md-card>
          <md-card-content>
            <div class="text-right">
              <md-button class="md-raised md-success"
              href="https://apix-dashboard-public-assets.s3.us-east-2.amazonaws.com/Bulk+Account+Creation+Guide.pdf"
              download>Download Template</md-button>
              <md-button class="md-primary" @click="uploadDetail()"
                >Add Bulk Account</md-button
              >
            </div>
            <div>
              <div>
                 <md-table table-header-color="green" >
                  <!-- Table Row -->
                  <md-table-row>
                    <md-table-head>S/N</md-table-head>
                    <md-table-head>Date</md-table-head>
                    <md-table-head>Customer Phone</md-table-head>
                    <md-table-head>Customer Name</md-table-head>
                    <md-table-head>Meter Number</md-table-head>
                    <md-table-head>Disco</md-table-head>
                    <md-table-head>Bank Name</md-table-head>
                    <md-table-head>Account Number</md-table-head>
                    <md-table-head>Account Name</md-table-head>
                    <md-table-head>Used</md-table-head>
                    <md-table-head>Reference</md-table-head>
                  </md-table-row>
                  <!-- Empty Data -->
                  <md-table-row v-if="transactions.length < 1">
                    <md-table-cell colspan="9">
                      <p>No record found.</p>
                    </md-table-cell>
                  </md-table-row>

                  <md-table-row
                    v-for="(transaction, index) in transactions"
                    :key="index"
                  >
                    <md-table-cell>{{ index + 1 }}</md-table-cell>
                    <md-table-cell md-label="Date">
                      {{ format(transaction.created_at, 'DD/MM/YYYY hh:mm a') }}
                    </md-table-cell>
                    <md-table-cell md-label="Customer Phone">
                      {{ transaction.phone }}
                    </md-table-cell>
                    <md-table-cell md-label="Customer Name">
                      {{ specialPhones[transaction.user.phone] ? transaction.facility.owner
                      : (transaction.user.name || transaction.user.phone) }}
                    </md-table-cell>
                    <md-table-cell md-label="Meter/ Account Number">
                      {{ transaction.meter }}
                    </md-table-cell>
                    <md-table-cell md-label="Disco">
                      {{ transaction.disco }}
                    </md-table-cell>
                    <md-table-cell md-label="Bank">
                      {{ transaction.bank }}
                    </md-table-cell>
                    <md-table-cell md-label="Account Number">
                      {{ transaction.acc_num }}
                    </md-table-cell>
                    <md-table-cell md-label="Account Name">
                      {{ transaction.acc_name }}
                    </md-table-cell>
                    <md-table-cell md-label="Used">
                      {{ transaction.used }}
                    </md-table-cell>
                    <md-table-cell md-label="Virtual Account Reference">
                      {{ transaction.ref }}
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <br />
                <div class="md-center" v-if="transactions.length > 28">
                  <md-button class="md-primary" @click="loadMore()"
                    >Load More</md-button
                  >
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <UploadModal ref="uploadModal" />
    <ExportModal ref="exportModal" :fields="exportFields" :onStart="fetchMeta"
    :specialPhones="specialPhones" />
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { format } from 'date-fns';
import moment from 'moment';
import UploadModal from './UploadModal.vue';
import ExportModal from '../../components/ExportModal.vue';
import http from '../../utils/Http.util';
import {
  formatAmount,
  commaNumber,
  formatToken,
} from '../../utils/Formatter.util';

export default {
  components: {
    UploadModal,
    ExportModal,
  },
  watch: {
    dateFilter(view) {
      let from = new Date();
      let to = new Date();

      switch (view) {
        default:
          from = null;
          to = null;
          this.showDatePicker = false;
          break;
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'CUSTOM':
          this.showDatePicker = true;
          return;
      }
      this.transactionQuery.start = from;
      this.transactionQuery.end = to;
    },
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    isLive() {
      return this.$store.state.isLive;
    },
  },
  data() {
    return {
      selected: {},
      testDate: format(new Date(), 'YYYY-MM-DD'),
      dateFilter: 'ALL',
      showDatePicker: false,
      summary: {
        wallet: 0,
        transactions: {
          sum: 0,
          count: 0,
        },
        commission: 0,
      },
      dialog: {
        active: false,
        id: null,
        transactionDetail: { vendResponse: {} },
      },
      snackBar: {
        show: false,
        message: null,
      },
      discos: [
        'ABUJA',
        'KADUNA',
        'KANO',
        'JOS',
        'ENUGU',
        'PH',
        'EKO',
        'IKEJA',
        'IBADAN',
      ],
      verticals: ['tv', 'electricity'],
      vendStatus: ['SUCCESS', 'FAILED', 'PENDING', 'CANCELLED'],
      transactions: [],
      transactionQuery: {
        order_id: '',
        merchant_id: '',
        page: 1,
        limit: 30,
        start: null,
        end: null,
        filteredQuery: {},
        // start: format(new Date(), "YYYY-MM-DD"),
        // end: format(new Date(), "YYYY-MM-DD"),
        meterNo: '',
        checkpoint: null,
        order: JSON.stringify([['created_at', 'DESC']]),
        get created_at() {
          if (this.start && this.end) {
            this.end.setHours(23);
            this.end.setMinutes(59);
            this.end.setSeconds(59);

            return {
              $between: [this.start.toString(), this.end.toString()],
            };
          }

          return { $between: [this.start, this.end] };
        },
      },
      current: null,
      filterQuery: {},
      totalPages: 1,
      GTBANK_ID: '1253797',
      providers: ['dstv', 'gotv'],
      vendTypes: ['prepaid', 'postpaid'],
      loading: false,
      isRequerying: false,
      exportFields: ['ID', 'Reference', 'Phone', 'Customer_name', 'Meter', 'Disco', 'Bank', 'Bank_code', 'Account_name', 'Account_num', 'active', 'used', 'created_at', 'generated_by'],
      specialPhones: {
        '09000000001': true,
      // add more phone numbers here
      },
    };
  },
  methods: {
    async loadView(view) {
      // Pick date from state
      let from = new Date();
      let to = new Date();

      switch (view) {
        default:
          from = null;
          to = null;
          this.showDatePicker = false;
          break;
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'CUSTOM':
          this.showDatePicker = true;
          return;
      }

      this.transactionQuery.start = from;
      this.transactionQuery.end = to;

      await this.filterTransactions();
    },
    getExportFileName() {
      const filename = `Virtual Accounts Export - ${format(Date.now(), 'DD/MM/YYYY hh:mm a')}`;
      return filename;
    },
    commaNumber,
    formatAmount,
    formatToken,
    format,
    async fetchData(page, downloadLimit) {
      const {
        limit, checkpoint, order, filteredQuery,
      } = this.transactionQuery;
      const queryLimit = downloadLimit || limit;
      try {
        const { data } = await http.authReq(
          `/dashboard/virtual-accounts?checkpoint=${checkpoint}&limit=${queryLimit}&page=${page}&order=${order}`,
          {
            where: filteredQuery,
          },
        );
        return data;
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
        return [];
      }
    },

    async getTransactions() {
      this.$store.commit('busyStatus', true);
      try {
        this.$store.commit('setTransactionQuery', this.transactionQuery);
        if (!this.discos.includes(this.transactionQuery.discoCode)) { this.transactionQuery.discoCode = ''; }
        if (this.transactionQuery.phone && this.transactionQuery.merchantId) {
          this.transactionQuery.merchantId = '';
          this.$router.replace({
            ...this.$router.currentRoute,
            query: {},
          });
        }
        const { data } = await http.authReq('/dashboard/virtual-accounts');
        this.transactionQuery.checkpoint = data.length > 0 ? data[0].created_at : null;
        this.transactions = data;
        this.$store.commit('setTransactions', data);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }
      this.$store.commit('busyStatus', false);
    },
    uploadDetail() {
      this.$refs.uploadModal.open();
    },
    openModal(id) {
      this.dialog.active = true;
      this.loading = true;

      this.getOrder(id)
        .then((order) => {
          this.current = order;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async loadMore() {
      this.$store.commit('busyStatus', true);

      const {
        order,
        checkpoint,
        limit,
        page,
        filteredQuery,
      } = this.transactionQuery;

      const nextPage = page + 1;

      try {
        const { data } = await http.authReq(
          `/dashboard/virtual-accounts?checkpoint=${checkpoint}&limit=${limit}&page=${nextPage}&order=${order}`,
          {
            where: filteredQuery,
          },
        );

        if (data.length <= 0) {
          this.snackBar = {
            show: true,
            message: 'Nothing more to load.',
          };
        } else {
          this.transactions = [...this.transactions, ...data];

          this.transactionQuery.page = nextPage;

          this.$store.commit('setTransactions', [...this.transactions, ...data]);
        }
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      }

      this.$store.commit('busyStatus', false);
    },

    async filterTransactions() {
      this.$store.commit('busyStatus', true);

      try {
        const { order, created_at, term } = this.transactionQuery;
        let query = created_at.$between[0] ? { created_at } : {};
        if (term) {
          query = {
            ...query,
            $or: [
              { phone: term.trim() },
              { meter: term.trim() },
            ],
          };
        }

        if (Object.keys(this.filterQuery).length > 0) {
          query = {
            ...query,
            ...this.filterQuery,
          };
        }

        const jsonQuery = JSON.stringify(query);
        // const jsonQuery = stringifyDate.stringify(query);

        const { data } = await http.authReq(
          `/dashboard/virtual-accounts?order=${order}`,
          {
            where: jsonQuery,
          },
        );

        this.transactionQuery.checkpoint = data.length > 0 ? data[0].created_at : null;
        this.transactionQuery.filteredQuery = jsonQuery;
        this.transactions = data;
        this.$store.commit('setTransactions', data);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      } finally {
        this.$store.commit('busyStatus', false);
      }
    },
    targetField(field, data) {
      if (data) {
        this.filterQuery[field] = data;
      } else if (this.filterQuery[field]) {
        delete this.filterQuery[field];
      }
    },
    async resetQuery() {
      this.dateFilter = 'ALL';
      this.showDatePicker = false;
      await this.getTransactions();
      this.filterQuery = {};
      const fields = document.querySelectorAll('.md-input');
      for (let key = 0; key < fields.length; key += 1) {
        fields[key].value = '';
      }
    },
    exportToExcel() {
      this.$refs.exportModal.open();
    },
    closeModal() {
      this.dialog.active = false;
      this.current = null;
    },
  },
  mounted() {
    this.loadView('ALL');
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.md-table .md-table-row {
  cursor: pointer;
}
.md-datepicker {
  z-index: 1 !important;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.close {
  padding: 4px;
  // background: #a3a3a3;
  border-radius: 50%;
  font-size: 20px;
  font-weight: bold;
  &:hover {
    cursor: pointer;
  }
}
.table-body {
  // width: 100%;
  overflow-x: auto;
  scroll-behavior: auto;
  // max-width: 50%;
}

.md-dialog /deep/.md-dialog-container {
  max-width: 100%;
}
.dropdown {
  span {
    padding: 0 24px !important;
  }
}

.body {
  max-width: 100%;
}
</style>

<style lang="scss" scoped>
.page-btn {
  margin-right: 20px;
  font-size: 20px !important;
}
.dropdown-search {
  width: 90%;
  height: 30px;
  margin: 0 auto;
  margin-bottom: 5px;
  box-shadow: none;
}
</style>
